import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { motion } from 'framer-motion';
/**
 * Lampshade Effect: Scale & fade out vertically
 * Used for collapsible components with smooth spring physics
 */
export const lampshadeVariants = {
    visible: {
        opacity: 1,
        scaleY: 1,
        scaleX: 1,
        height: 'auto',
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            duration: 0.4,
        },
    },
    collapsed: {
        opacity: 0,
        scaleY: 0.1,
        scaleX: 0.95,
        height: 0,
        transition: {
            type: 'spring',
            stiffness: 400,
            damping: 35,
            duration: 0.3,
        },
    },
};
export const lampshadeVariantsFast = {
    visible: {
        opacity: 1,
        scaleY: 1,
        scaleX: 1,
        height: 'auto',
        transition: {
            type: 'spring',
            stiffness: 500,
            damping: 40,
            duration: 0.2,
        },
    },
    collapsed: {
        opacity: 0,
        scaleY: 0.1,
        scaleX: 0.95,
        height: 0,
        transition: {
            type: 'spring',
            stiffness: 600,
            damping: 45,
            duration: 0.15,
        },
    },
};
export const lampshadeVariantsGentle = {
    visible: {
        opacity: 1,
        scaleY: 1,
        scaleX: 1,
        height: 'auto',
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 25,
            duration: 0.6,
        },
    },
    collapsed: {
        opacity: 0,
        scaleY: 0.1,
        scaleX: 0.95,
        height: 0,
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            duration: 0.5,
        },
    },
};
/**
 * Cascade effect for multiple items appearing
 * Used for mountains appearing when range expands
 */
export const cascadeContainerVariants = {
    visible: {
        transition: {
            staggerChildren: 0.08,
            delayChildren: 0.1,
        },
    },
    collapsed: {
        transition: {
            staggerChildren: 0.05,
            staggerDirection: -1,
        },
    },
};
export const cascadeItemVariants = {
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
        },
    },
    collapsed: {
        opacity: 0,
        y: -10,
        transition: {
            type: 'spring',
            stiffness: 400,
            damping: 35,
        },
    },
};
/**
 * Pulse effect for interactive elements
 * Used for Mountain cards on tap/hover
 */
export const pulseVariants = {
    tap: {
        scale: 0.98,
        transition: { duration: 0.1 },
    },
    hover: {
        scale: 1.02,
        transition: { duration: 0.2 },
    },
    normal: {
        scale: 1,
        transition: { duration: 0.2 },
    },
};
/**
 * Rotate effect for loading states
 */
export const rotateLoadingVariants = {
    animate: {
        rotate: 360,
        transition: {
            duration: 2,
            repeat: Infinity,
            ease: 'linear',
        },
    },
};
/**
 * Slide in from bottom
 */
export const slideUpVariants = {
    hidden: {
        opacity: 0,
        y: 40,
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            duration: 0.4,
        },
    },
    exit: {
        opacity: 0,
        y: 40,
        transition: { duration: 0.2 },
    },
};
/**
 * Fade in
 */
export const fadeVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: { duration: 0.3 },
    },
    exit: {
        opacity: 0,
        transition: { duration: 0.2 },
    },
};
export function LampshadeContainer({ isCollapsed, children, variant = 'default', transformOrigin = 'top', className = '', }) {
    const variantMap = {
        default: lampshadeVariants,
        fast: lampshadeVariantsFast,
        gentle: lampshadeVariantsGentle,
    };
    return (_jsx(motion.div, { variants: variantMap[variant], initial: "visible", animate: isCollapsed ? 'collapsed' : 'visible', style: { transformOrigin }, className: className, children: children }));
}
